// Models
import { ContainerType } from "@ms/planner-models/lib/local/service/planner/enumerations/IPlannerEnumerations";
// Resources
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
/**
 * Get the admin-blocked access error strings for a given container type.
 * Today only Teams channel containers can be blocked by a tenant admin; the switch
 * makes it straightforward to add container-type-specific strings in the future.
 * @param containerType The container type whose access has been blocked
 */ export function getAdminBlockedAccessString(containerType) {
    switch(containerType){
        case ContainerType.TeamsChannel:
            return {
                errorText: Strings.TeamsChannel_AdminBlockedAccessErrorMessage,
                errorSubText: Strings.TeamsChannel_AdminBlockedAccessErrorDetailMessage
            };
        default:
            return {
                errorText: "",
                errorSubText: ""
            };
    }
}
